
import evenementen from '~/graphql/queries/evenementen';
import page from '~/plugins/mixins/page';

export default {
  mixins: [page],
  auth: false,
  data: () => ({
    currentPage: 1,
    filters: [],
    evenementen: {data: []},
  }),
  apollo: {
    evenementen: {
      query: evenementen,
      variables() {
        return {
          limit: 8,
          page: 1,
        };
      },
    },
  },
  computed: {
    events() {
      return this.evenementen.data.filter(e => e.slug !== this.highlight?.slug);
    },
    highlights() {
      return this.evenementen.data.filter(evenement => evenement.highlight);
    },
    highlight() {
      return this.highlights?.[0];
    },
  },
  methods: {
    loadMore() {
      this.currentPage++;
      this.$apollo.queries.evenementen.fetchMore({
        variables: {
          page: this.currentPage,
          limit: 8,
        },
        updateQuery: (previousResult, {fetchMoreResult}) => {
          const newServices = fetchMoreResult.evenementen.data;
          const hasMorePages = fetchMoreResult.evenementen.has_more_pages;
          return {
            services: {
              __typename: previousResult.evenementen.__typename,
              data: [...previousResult.evenementen.data, ...newServices],
              has_more_pages: hasMorePages,
              current_page: this.currentPage,
              last_page: this.evenementen.last_page,
            },
          };
        },
      });
    },
    toggleFilter(slug) {
      if (this.filters.includes(slug)) {
        this.filters = this.filters.filter(filter => filter !== slug);
      } else {
        this.filters.push(slug);
      }
    },
    changeFilters(val) {
      this.filters = val;
    },
  },
};
